(function() {
	'use strict';
	angular.module('app.setup')
		.service('inventoryActionConfigService', inventoryActionConfigService);

	inventoryActionConfigService.$inject = ['URLS', '$http', 'inventoryActionsService'];

	function inventoryActionConfigService(URLS, $http, inventoryActionsService) {
		return {
			getActions: getActions,
			getSuppliers: getSuppliers,
			getItemGroups: getItemGroups,
			getMaterialGroups: getMaterialGroups,
			getMaterialTypes: getMaterialTypes,
			saveInventoryActionConfig: saveInventoryActionConfig,
			getDefaultResponsible: getDefaultResponsible,
			getExcessToSellDefaultResponsible: getExcessToSellDefaultResponsible,
			saveDefaultResponsible: saveDefaultResponsible,
			saveExcessToSellDefaultResponsible: saveExcessToSellDefaultResponsible,
			getUnableToFixCategories: getUnableToFixCategories,
			addUnableToFixCategory: addUnableToFixCategory,
			removeUnableToFixCategory: removeUnableToFixCategory,
			updateUnableToFixCategory: updateUnableToFixCategory,
			updateAllInventoryActionConfigState: updateAllInventoryActionConfigState,
			getFactoriesForUserAndCustomer: getFactoriesForUserAndCustomer,
			saveExcessToSellBlackListSites: saveExcessToSellBlackListSites,
			getInventoryActionBlackListSites: getInventoryActionBlackListSites,
			updateUnableToFixCategories: updateUnableToFixCategories,
			getProcurementTaskCategories: getProcurementTaskCategories
		};

		function getActions(siteId) {
			var url = URLS.host + String.format(URLS.inventoryActionConfigurations, siteId);
			return getData(url);
		}

		function getSuppliers(siteId) {
			var url = URLS.host + String.format(URLS.suppliers, siteId);
			return getData(url);
		}

		function getItemGroups(siteId) {
			var url = URLS.host + String.format(URLS.itemGroups, siteId);
			return getData(url);
		}

		function getMaterialGroups(siteId) {
			var url = URLS.host + String.format(URLS.materialGroups, siteId);
			return getData(url);
		}

		function getMaterialTypes(siteId) {
			var url = URLS.host + String.format(URLS.materialTypes, siteId);
			return getData(url);
		}

		function getDefaultResponsible(siteId) {
			var url = URLS.host + String.format(URLS.inventoryActionDefaultResponsible, siteId);
			return getData(url);
		}

		function getExcessToSellDefaultResponsible(siteId) {
			var url = URLS.host + String.format(URLS.inventoryActionExcessToSellDefaultResponsible, siteId);
			return getData(url);
		}

		function getInventoryActionBlackListSites(siteId) {
			var url = URLS.host + String.format(URLS.inventoryActionBlackListSites, siteId);
			return getData(url);
		}

		function getData (url) {
			return $http.get(url)
				.then(getDataSuccess, getDataError);

			function getDataSuccess(response) {
				return response.data;
			}
			function getDataError(error) {
				return error;
			}
		}

		function saveInventoryActionConfig(siteId, inventoryAction) {
			var url = URLS.host + String.format(URLS.inventoryActionConfigurations, siteId);
			return $http.put(url, inventoryAction)
				.then(updateInventoryActionComplete)
				.catch(updateInventoryActionFailed);

			function updateInventoryActionComplete(response) {
				return response.data;
			}
			function updateInventoryActionFailed(error) {
				return error;
			}
		}

		function updateAllInventoryActionConfigState(siteId, enabled) {
			var url = URLS.host + String.format(URLS.inventoryActionConfigurationsState, siteId);
			return $http.put(url, {
				'enabled': enabled,
				'actions': inventoryActionsService.getDefaultEnabledActions()
			})
				.then(updateInventoryActionComplete)
				.catch(updateInventoryActionFailed);

			function updateInventoryActionComplete(response) {
				return response.data;
			}
			function updateInventoryActionFailed(error) {
				return error;
			}
		}

		function saveDefaultResponsible(siteId, userNdx) {
			var url = URLS.host + String.format(URLS.inventoryActionDefaultResponsible, siteId);
			return $http.put(url, userNdx)
				.then(updateDefaultResponsibleComplete)
				.catch(updateDefaultResponsibleFailed);

			function updateDefaultResponsibleComplete(response) {
				return response.data;
			}
			function updateDefaultResponsibleFailed(error) {
				return error;
			}
		}

		function saveExcessToSellDefaultResponsible(siteId, userNdx) {
			var url = URLS.host + String.format(URLS.inventoryActionExcessToSellDefaultResponsible, siteId);
			return $http.put(url, userNdx)
				.then(updateExcessToSellDefaultResponsibleComplete)
				.catch(updateExcessToSellDefaultResponsibleFailed);

			function updateExcessToSellDefaultResponsibleComplete(response) {
				return response.data;
			}
			function updateExcessToSellDefaultResponsibleFailed(error) {
				return error;
			}
		}

		function saveExcessToSellBlackListSites(siteId, blackListSites) {
			var url = URLS.host + String.format(URLS.inventoryActionBlackListSites, siteId);
			return $http.put(url, blackListSites)
				.then(updateExcessToSellBlackListSitesComplete)
				.catch(updateExcessToSellBlackListSitesFailed);

			function updateExcessToSellBlackListSitesComplete(response) {
				return response.data;
			}
			function updateExcessToSellBlackListSitesFailed(error) {
				return error;
			}
		}

		function getUnableToFixCategories(siteId, hideInactive) {
			var url = URLS.host + String.format(URLS.inventoryActionUnableToFixCategories, siteId);
			if (!hideInactive){
				url += '?includeInactive=true';
			}
			return $http.get(url)
				.then(getUnableToFixCategoriesSuccess)
				.catch(getUnableToFixCategoriesFailed);
			
			function getUnableToFixCategoriesSuccess(response) {
				if (response && response.data && response.data.length) {
					var index = -1;
					for (var i = 0; i < response.data.length; i++) {
						if (response.data[i] && response.data[i].categoryName === 'Other...') {
							index = i;
							break;
						}
					}
					if (index >= 0) {
						response.data.push(response.data.splice(index, 1)[0]);
					}
				}
				return response.data;
			}

			function getUnableToFixCategoriesFailed(error) {
				return [];
			}
		}

		function getProcurementTaskCategories(siteId, hideInactive) {
			var url = URLS.host + String.format(URLS.procurementTaskCategories, siteId);
			if (!hideInactive){
				url += '?includeInactive=true';
			}
			return $http.get(url)
				.then(getProcurementTaskCategoriesSuccess)
				.catch(getProcurementTaskCategoriesFailed);

			function getProcurementTaskCategoriesSuccess(response) {
				return response.data;
			}

			function getProcurementTaskCategoriesFailed(error) {
				return [];
			}
		}

		function addUnableToFixCategory(siteId, newCategory) {
			var url = URLS.host + String.format(URLS.inventoryActionUnableToFixCategory, siteId);
			return $http.post(url, newCategory)
				.then(addUnableToFixCategorySuccess)
				.catch(addUnableToFixCategoryFailed);
			
			function addUnableToFixCategorySuccess(response) {
				return response;
			}

			function addUnableToFixCategoryFailed(error) {
				return error;
			}
		}

		function removeUnableToFixCategory(siteId, categoryId) {
			var url = URLS.host + String.format(URLS.inventoryActionUnableToFixCategory, siteId) + '/' + categoryId;
			return $http.delete(url)
				.then(removeUnableToFixCategorySuccess)
				.catch(removeUnableToFixCategoryFailed);

			function removeUnableToFixCategorySuccess(response) {
				return response;
			}

			function removeUnableToFixCategoryFailed(error) {
				return error;
			}
		}

		function updateUnableToFixCategory(siteId, saveObj) {
			var url = URLS.host + String.format(URLS.inventoryActionUnableToFixCategory, siteId) + '/' + saveObj.ndx;
			return $http.put(url, saveObj)
				.then(updateUnableToFixCategorySuccess)
				.catch(updateUnableToFixCategoryFailed);

			function updateUnableToFixCategorySuccess(response) {
				return response;
			}

			function updateUnableToFixCategoryFailed(error) {
				return error;
			}
		}

		function updateUnableToFixCategories(siteId, ids, saveObjs) {
			var url = URLS.host + String.format(URLS.InventoryActionUnableToFixCategories, siteId) + '/' + ids;
			return $http.put(url, saveObjs)
				.then(updateUnableToFixCategorySuccess)
				.catch(updateUnableToFixCategoryFailed);

			function updateUnableToFixCategorySuccess(response) {
				return response;
			}

			function updateUnableToFixCategoryFailed(error) {
				return error;
			}
		}

		function getFactoriesForUserAndCustomer(siteId) {
			var url = URLS.host + '2/Dimensions/Factories?excludeSelf=true&excludeExternalSite=true&allCustomers=false&opsFactNdx=' + (siteId || globalConfig.factory.id);
			url += '&customerNdx=' + globalConfig.customer.id;
			return $http.get(url)
				.then(getFactoriesForUserAndCustomerSuccess)
				.catch(getFactoriesForUserAndCustomerFailed);

			function getFactoriesForUserAndCustomerSuccess(response) {
				return response.data;
			}

			function getFactoriesForUserAndCustomerFailed(error) {
				return [];
			}
		}
	}
})();
